function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10.23,
    height: 1.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.2783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 0.835
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.67,
    width: 10.23,
    height: 7.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3133333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 5.609999999999999
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.55,
    width: 10.23,
    height: 11.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 15.355
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.16,
    width: 10.23,
    height: 19.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.27875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 31.055
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.95,
    width: 10.23,
    height: 21.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0460000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 51.735
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.52,
    width: 10.23,
    height: 21.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4614285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 73.44
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84.36,
    width: 10.23,
    height: 30.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 99.47
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.58,
    width: 10.23,
    height: 34.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 131.645
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.71,
    width: 10.23,
    height: 35.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 166.505
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.3,
    width: 10.23,
    height: 37.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 202.82500000000002
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221.36,
    width: 10.23,
    height: 38.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 240.615
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 259.87,
    width: 10.23,
    height: 41.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 280.4
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300.93,
    width: 10.23,
    height: 41.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0230000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 321.495
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 342.06,
    width: 10.23,
    height: 44.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 364.14
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 386.22,
    width: 10.23,
    height: 47.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0460000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 409.79
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 433.36,
    width: 10.23,
    height: 60.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 463.44
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.52,
    width: 10.23,
    height: 60.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.27875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 523.63
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 553.74,
    width: 10.23,
    height: 72.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 590.0550000000001
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626.37,
    width: 10.23,
    height: 73.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.115,
    y: 663.185
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 0,
    width: 20.98,
    height: 37.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.72,
    y: 18.99
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.22,
    y: 0,
    width: 24.43,
    height: 37.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.05375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.435,
    y: 18.99
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.65,
    y: 0,
    width: 25.45,
    height: 37.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.241666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.375,
    y: 18.99
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.1,
    y: 0,
    width: 25.88,
    height: 37.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.03999999999999,
    y: 18.99
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.98,
    y: 0,
    width: 27.12,
    height: 37.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0133333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.54,
    y: 18.99
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 0,
    width: 31.86,
    height: 37.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.03,
    y: 18.99
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.95,
    y: 0,
    width: 32.21,
    height: 37.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.442
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.05499999999998,
    y: 18.99
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.16,
    y: 0,
    width: 36.38,
    height: 37.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.35,
    y: 18.99
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.54,
    y: 0,
    width: 50.44,
    height: 37.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.329999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.76,
    y: 18.99
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.98,
    y: 0,
    width: 51.53,
    height: 37.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.745,
    y: 18.99
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.51,
    y: 0,
    width: 51.86,
    height: 37.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.329999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.44,
    y: 18.99
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.36,
    y: 0,
    width: 52.01,
    height: 37.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.329999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.365,
    y: 18.99
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 0,
    width: 58.03,
    height: 37.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.385,
    y: 18.99
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.4,
    y: 0,
    width: 64.43,
    height: 37.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.615,
    y: 18.99
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.83,
    y: 0,
    width: 67.4,
    height: 37.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5319999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.5300000000001,
    y: 18.99
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.23,
    y: 0,
    width: 69.77,
    height: 37.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.115,
    y: 18.99
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 37.98,
    width: 65.54,
    height: 51.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.149
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 63.724999999999994
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 89.47,
    width: 65.54,
    height: 52.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 115.735
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 142,
    width: 65.54,
    height: 57.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 170.965
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 199.94,
    width: 65.54,
    height: 67.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 233.48
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 267.02,
    width: 65.54,
    height: 69.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 301.625
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 336.23,
    width: 65.54,
    height: 80.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.923333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 376.47
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 416.71,
    width: 65.54,
    height: 85.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 459.37
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 502.03,
    width: 65.54,
    height: 96.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.041538461538462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 550.1899999999999
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 598.35,
    width: 65.54,
    height: 101.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.958181818181819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43,
    y: 649.1750000000001
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 37.98,
    width: 74.57,
    height: 104.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.6425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.05499999999999,
    y: 90.465
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.34,
    y: 37.98,
    width: 74.84,
    height: 104.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.691428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.76,
    y: 90.465
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 37.98,
    width: 88.45,
    height: 104.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.741666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.40500000000003,
    y: 90.465
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.63,
    y: 37.98,
    width: 101.5,
    height: 104.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.277777777777779
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.38,
    y: 90.465
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.12,
    y: 37.98,
    width: 140.93,
    height: 104.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.58500000000004,
    y: 90.465
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.05,
    y: 37.98,
    width: 143.95,
    height: 104.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.497857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.025,
    y: 90.465
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 142.94,
    width: 135.52,
    height: 112.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.502222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.53,
    y: 199.2
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 255.46,
    width: 135.52,
    height: 116.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.629999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.53,
    y: 313.61
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 371.76,
    width: 135.52,
    height: 149.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.424615384615386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.53,
    y: 446.53999999999996
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 521.32,
    width: 135.52,
    height: 178.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.53,
    y: 610.6600000000001
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.29,
    y: 142.94,
    width: 145.21,
    height: 189.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.744285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.895,
    y: 237.715
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.5,
    y: 142.94,
    width: 165.72,
    height: 189.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.413333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.36,
    y: 237.715
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.22,
    y: 142.94,
    width: 177.78,
    height: 189.55,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.11,
    y: 237.715
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.29,
    y: 332.49,
    width: 488.71,
    height: 367.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.645,
    y: 516.245
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.f59bf3d12443d8a58a6456f3626aeaa6.svg";
export { ForwardRef as ReactComponent };